module.exports = __webpack_public_path__ + "img/Art13_20170667-001.d794e0cc.jpg";